// extracted by mini-css-extract-plugin
module.exports = {"container":"e_TX","cardLeft":"e_UX","cardRight":"e_VX","rowLeft":"e_WX","rowRight":"e_XX"};